import isDistributor from '@/middlewares/isDistributor';
export default [
    /**
     * FOR DISTRIBUTOR ONLY
     */

    {
        path: '/distributor-dashboard',
        component: () => import('@/views/distributor/Dashboard.vue'),
        name: 'DistributorDashboard',
        addtoNav: false,
        meta: {
            navText: 'Dashboard',
            middleware: [isDistributor]
        }
    },

    // old route
    // {
    //     path: '/distributor-reg-product',
    //     component: () => import('@/views/distributor/Registeredproducts.vue'),
    //     name: 'DistributorRegisteredProducts',
    //     addtoNav: false,
    //     meta: {
    //         navText: 'Registered Products',
    //         middleware: [isDistributor]
    //     }
    // },
    {
        path: '/distributor-reg-product',
        component: () => import('@/views/distributor/v2/RegisteredProducts.vue'),
        name: 'DistributorRegisteredProducts',
        addtoNav: false,
        meta: {
            navText: 'Registered Products',
            middleware: [isDistributor]
        }
    },

    {
        path: '/distributor-reg-product-warranty-request',
        component: () => import('@/views/distributor/v2/RegisteredProductsWarrantyRequest.vue'),
        name: 'DistributorRegisteredProductsWarrantyRequest',
        addtoNav: false,
        meta: {
            navText: 'Request Warranty Products',
            middleware: [isDistributor]
        }
    },

    {
        path: '/distributor-reg-product-warranty-request/active',
        component: () => import('@/views/distributor/v2/RegisteredProductsWarrantyActive.vue'),
        name: 'DistributorRegisteredProductsWarrantyActive',
        addtoNav: false,
        meta: {
            navText: 'Active Warranty Products',
            middleware: [isDistributor]
        }
    },
    {
        path: '/distributor-reg-product-warranty-request/closed',
        component: () => import('@/views/distributor/v2/RegisteredProductsWarrantyClose.vue'),
        name: 'DistributorRegisteredProductsWarrantyClose',
        addtoNav: false,
        meta: {
            navText: 'Closed Warranty Products',
            middleware: [isDistributor]
        }
    },

    // Repair
    {
        path: '/distributor-reg-product-request-repair',
        component: () => import('@/views/distributor/v2/RegisteredProductsRequestRepair.vue'),
        name: 'DistributorRegisteredProductsRepairRequest',
        addtoNav: false,
        meta: {
            navText: 'Repair Request',
            middleware: [isDistributor]
        }
    },
    {
        path: '/distributor-reg-product-request-repair/active',
        component: () => import('@/views/distributor/v2/RegisteredProductsActiveRepair.vue'),
        name: 'DistributorRegisteredProductsRepairActive',
        addtoNav: false,
        meta: {
            navText: 'Repair Active',
            middleware: [isDistributor]
        }
    },
    {
        path: '/distributor-reg-product-request-repair/closed',
        component: () => import('@/views/distributor/v2/RegisteredProductsClosedRepair.vue'),
        name: 'DistributorRegisteredProductsRepairClosed',
        addtoNav: false,
        meta: {
            navText: 'Repair Closed',
            middleware: [isDistributor]
        }
    },

    {
        path: '/distributor-reg-product/add',
        component: () => import('@/views/distributor/RegisteredProductAdd.vue'),
        name: 'DistributorRegisteredProductAdd',
        addtoNav: false,
        meta: {
            navText: 'Registered Products Add',
            middleware: [isDistributor]
        }
    },

    {
        path: '/distributor-reg-product/:id/edit',
        component: () => import('@/views/distributor/RegisteredProductEdit.vue'),
        name: 'DistributorRegisteredProductEdit',
        addtoNav: false,
        meta: {
            navText: 'Registered Products Edit',
            middleware: [isDistributor]
        }
    },

    {
        path: '/distributor-resellers',
        component: () => import('@/views/distributor/Resellers.vue'),
        name: 'DistributorResellers',
        addtoNav: false,
        meta: {
            navText: 'Resellers',
            middleware: [isDistributor]
        }
    },
    {
        path: '/distributor-resellers-map',
        component: () => import('@/views/distributor/ResellersMap.vue'),
        name: 'DistributorResellersMap',
        addtoNav: false,
        meta: {
            navText: 'Resellers Map',
            middleware: [isDistributor]
        }
    },
    {
        path: '/distributor-customers',
        component: () => import('@/views/distributor/Customers.vue'),
        name: 'DistributorCustomers',
        addtoNav: false,
        meta: {
            navText: 'Customers',
            middleware: [isDistributor]
        }
    },

    {
        path: '/distributor-customers/add',
        component: () => import('@/views/distributor/CustomerAdd.vue'),
        name: 'DistributorCustomerAdd',
        addtoNav: false,
        meta: {
            navText: 'Customers',
            middleware: [isDistributor]
        }
    },
    {
        path: '/distributor-customers/:customer_id/edit',
        component: () => import('@/views/distributor/CustomerEdit.vue'),
        name: 'DistributorCustomerEdit',
        addtoNav: false,
        meta: {
            navText: 'Customers',
            middleware: [isDistributor]
        }
    }
];
